import { ITDragHandle, ITDragHandleProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Sort'

export const OrderDragHandle: React.FC<ITDragHandleProps> = ({ ...all }) => {
    const readOnlyFnc = (allRowData: any) => !allRowData.ProductId || allRowData.processed
    return (
        <ITDragHandle readOnlyFnc={readOnlyFnc} {...all} />
    )
}